import type {JobDetail} from 'src/jobs/types'

/** Whether a job update can change assignment-strip data for assigned workers or assets. */
export function jobAssignmentStripDataChanged(previous: JobDetail, next: JobDetail): boolean {
    if (
        previous.startDate !== next.startDate ||
        previous.endDate !== next.endDate ||
        previous.startTime !== next.startTime ||
        previous.endTime !== next.endTime
    ) {
        return true
    }

    if (previous.assignments.length !== next.assignments.length) {
        return true
    }

    return previous.assignments.some((assignment, index) => {
        const nextAssignment = next.assignments[index]
        return (
            assignment.id !== nextAssignment?.id ||
            assignment.workerId !== nextAssignment?.workerId ||
            assignment.rentalAssetId !== nextAssignment?.rentalAssetId
        )
    })
}
